import { tlwTwMerge } from '@trg/utils';
import { Link, type LinkProps } from '@trg/tlw-ui-component';
import type { SubCategory } from '../../api';

export type ChildCategoryLinkProps = Omit<
  LinkProps,
  'href' | 'title' | 'children'
> & {
  category: SubCategory;
};

export function ChildCategoryLink({
  category,
  className,
  ...props
}: ChildCategoryLinkProps) {
  return (
    <Link
      className={tlwTwMerge(
        'tlw-line-clamp-1 tlw-txt-zh-head-8 tlw-text-txt-700 tlw-w-fit tlw-duration-300 hover:tlw-text-txt-core lg:tlw-px-1',
        className
      )}
      href={category.link}
      title={category.title}
      {...props}
    >
      {category.title}
    </Link>
  );
}
